export const getRandomInt = (startInt = 0, endInt: number = Number.MAX_SAFE_INTEGER) => {
	return Math.floor(startInt + Math.random() * (endInt - startInt + 1));
};